import { BootstrapConfig } from 'core/type/BootstrapConfig.types';
import { MeasurementName } from 'core/constant/MeasurementName';
import { IMeasurementTags } from '@agoda/messaging-client';
import { buildMeasurement } from 'core/service/measurements/measurementUtils';
import { logInfo, logWarn } from 'core-framework/util/LogMessage';
import { UseQueryStateBaseResult } from 'store/api/api.types';
import { sendMeasurement } from 'core/messaging/measurement/measurement';
import { convertError } from 'store/api/apiUtils';
import { TranslationResult } from 'core/type/TranslationResult.types';
import { ActivitiesPageTypes } from 'core/constant/analytics/AnalyticsPageType';
import { MeasurementStatus } from 'core/constant/MeasurementStatus';
import { FieldValue } from 'core/constant/FieldValue';

const sendTranslationApiMeasurements = (
    message: string,
    measurementName: MeasurementName,
    pageTypeId: ActivitiesPageTypes,
    config: BootstrapConfig,
    tags: IMeasurementTags,
): boolean => {
    const measurement = buildMeasurement('getTranslationResult', measurementName, pageTypeId, message, 1, false, config);
    measurement.tags = {
        ...measurement.tags,
        ...tags,
    };
    sendMeasurement({ ...measurement, name: MeasurementName.ApiTranslationStatus }, pageTypeId);

    if (measurementName === MeasurementName.ApiTranslationSuccess) {
        logInfo(message, pageTypeId, measurement.tags);
        return true;
    }
    logWarn(message, pageTypeId, measurement.tags);
    return true;
};
export const measureTranslationApiResponse = (
    response: UseQueryStateBaseResult<TranslationResult>,
    reviewId: number,
    titleText: string,
    descriptionText: string,
    replyText: string,
    pageTypeId: ActivitiesPageTypes,
    config: BootstrapConfig,
): boolean => {
    const error = convertError(response.error) || { status: FieldValue.Undefined, message: FieldValue.Undefined };
    const messageLowerCase = error.message.toLowerCase();
    const measurementTags: IMeasurementTags = {
        statusCode: error.status.toString(),
        reviewId: reviewId.toString(),
        titleTextLength: titleText.length?.toString(),
        descriptionTextLength: descriptionText.length?.toString(),
        replyTextLength: replyText.length?.toString(),
        sourceLanguage: response.data?.languageId.toString() || FieldValue.Undefined,
        targetLanguage: config.language.locale,
    };
    if (response.isSuccess) {
        const translatedTitle = response.data?.title;
        const translatedDescription = response.data?.description;
        const translatedReply = response.data?.reply;
        measurementTags.status = MeasurementStatus.Success;
        if (!translatedTitle && !translatedDescription && !translatedReply) {
            return sendTranslationApiMeasurements('empty translated text', MeasurementName.ApiTranslationNoResult, pageTypeId, config, measurementTags);
        }
        return sendTranslationApiMeasurements('success', MeasurementName.ApiTranslationSuccess, pageTypeId, config, measurementTags);
    }

    measurementTags.status = MeasurementStatus.Failed;
    return sendTranslationApiMeasurements(messageLowerCase, MeasurementName.ApiTranslationError, pageTypeId, config, measurementTags);
};
